<template lang="pug">
  #app
    navbar(v-if="user && $router.history.current.path !== '/tracking' && !$router.history.current.meta.hideHeaderAndFooter" :class="{ 'mb-4': user.role !== 'driver' }")
    router-view.content
    Footer.footer.mt-3(
      v-if="user && !isDriverRole(user.role) && $router.history.current.path !== '/tracking' && !$router.history.current.meta.hideHeaderAndFooter"
    )
</template>

<script>
import Navbar from './components/UI/Navbar'
import Footer from './components/UI/Footer'
import { mapGetters, mapActions } from 'vuex'
import { isAuth } from './utils/authUtils'
import { isDriverRole } from './constants/userRoles'

export default {
  components: {
    Navbar,
    Footer
  },
  methods: {
    ...mapActions(['fetchUser']),
    isDriverRole,
    homeRouteName() {
      return isDriverRole(this.user.role) ? 'DeliverysView' : 'StoreDeliveryView' // Sólo por ahora TODO: Cambiar por futura home
    },
    checkAuth() {
      const { isPublic, roles } = this.$route.meta
      const name = this.$route.name
      if (isPublic) {
        if (this.user && name === 'Login') {
          this.$router.push({ name: this.homeRouteName() })
        }
      } else if (!this.user) {
        this.$router.push({ name: 'Login' })
      } else if (roles && !roles.includes(this.user.role)) {
        this.$router.push({ name: this.homeRouteName() })
      }
    },
    restoreUserFromLocalStorage() {
      const storedUser = JSON.parse(window.localStorage.getItem('user'))
      if (storedUser && storedUser.user.email) {
        this.$store.commit('LOGIN', { user: storedUser })
      }
    }
  },
  computed: {
    ...mapGetters(['user'])
  },
  watch: {
    user: {
      handler() {
        this.checkAuth()
        this.$store.dispatch('fetchPermissions')
      },
      immediate: true
    },
    $route() {
      this.checkAuth()
    }
  },
  mounted() {
    if (isAuth()) {
      this.fetchUser()
    }
    this.checkAuth()
  },
  created() {
    this.restoreUserFromLocalStorage()
  }
}
</script>
<style lang="scss" scoped>
#app {
  display: flex;
  flex-direction: column;

  .content {
    flex: 1 0 auto;
  }

  .footer {
    flex-shrink: 0;
  }
}
</style>
